<template>
  <span class="profileImg" :class="size"><img :class="isFit" :src="[src]" /></span>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'small'
    },
    src: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.img = this.$el.querySelector('img')
    // console.log(this.img)
    this.changeSize()
  },
  data: function () {
    return {
      img: null,
      isFit: null
    }
  },
  name: 'profile',
  methods: {
    changeSize () {
      if (this.img.complete) {
        this.$emit('size', this.img.width + ' * ' + this.img.height)
        this.changeSizeTimeout()
      } else {
        this.img.onload = () => {
          this.$emit('size', this.img.width + ' * ' + this.img.height)
          this.changeSizeTimeout()
        }
      }
    },
    changeSizeTimeout () {
      setTimeout(() => {
        console.log(this.img.width, this.img.height)
        if (this.img.width > this.img.height) {
          this.isFit = 'w'
        } else {
          this.isFit = 'h'
        }
      })
    }
  }
}
</script>

<style scoped>
.profileImg {
  display: flex;
  border-radius: 50%;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}
.small {
  width: 30px;
  height: 30px;
  min-width: 30px;
}
.big {
  height: 96px;
  width: 96px;
  min-width: 96px;
}
.medium {
  width: 45px;
  height: 45px;
  min-width: 45px;
}
.x-big {
  height: 200px;
  width: 200px;
  min-width: 200px;
}
img {
  object-fit: contain;
}
img.w {
  height: 100%;
  width: auto;
}
img.h {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Profile.vue